export const VenusLensLegacyAbi = [
  {
    inputs: [
      {
        internalType: 'contract VToken',
        name: 'vToken',
        type: 'address',
      },
    ],
    name: 'vTokenMetadata',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'vToken',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'exchangeRateCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'reserveFactorMantissa',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalBorrows',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalReserves',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalSupply',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalCash',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'isListed',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'collateralFactorMantissa',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'underlyingAssetAddress',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'vTokenDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'underlyingDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'venusSupplySpeed',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'venusBorrowSpeed',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'dailySupplyXvs',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'dailyBorrowXvs',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'pausedActions',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'liquidationThresholdMantissa',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'liquidationIncentiveMantissa',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'isBorrowAllowed',
            type: 'bool',
          },
          {
            internalType: 'uint96',
            name: 'poolId',
            type: 'uint96',
          },
        ],
        internalType: 'struct VenusLens.VTokenMetadata',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
